(function() {
	'use strict';

	angular
		.module('assetCommon')
		.factory('tooltipService', tooltipService);

	function tooltipService($q, $timeout, $document, $animate, _, $) {
		var defaults = {
			tooltipDisplayDelay: 300,
			tooltipHideDelay: 100,
			tooltipFadeDuration: 200,
			tooltipOffset: 0,
			onDestroy: function () { }
		};

		var body = $document.find('body');
		function createTooltip(elem, initializeTooltip, options) {
			var mouseEnterPromise;
			var mouseLeavePromise;
			var tooltip = null;
			var tooltipInitializationAborter;

			options = _.extend({}, defaults, options);

			function beginShowTooltip(onShow) {
				$timeout.cancel(mouseLeavePromise);
				mouseEnterPromise = $timeout(function () {
					if (!tooltip) {
						tooltipInitializationAborter = $q.defer();

						initializeTooltip(tooltipInitializationAborter.promise)
							.then(function (tooltipElem) {
								tooltipInitializationAborter = null;
								if (!tooltipElem)
									return;

								tooltip = tooltipElem;
								showTooltip();

								if (onShow)
									onShow();
							});
					}
					else {
						showTooltip();
					}

				}, options.tooltipDisplayDelay, false);
			}

			function beginHideTooltip() {
				$timeout.cancel(mouseEnterPromise);
				mouseLeavePromise = $timeout(hideTooltip, options.tooltipHideDelay);
			}

			function showTooltip() {
				if (!tooltip)
					return;

				$animate.enter(tooltip, body, $(body[0].lastChild));

				reposition();
			}

			function destroyTooltip() {
				if (tooltip) {
					options.onDestroy(tooltip);
					tooltip.remove();
					tooltip = null;
				}
			}

			function hideTooltip() {
				if (tooltipInitializationAborter)
					tooltipInitializationAborter.resolve();
				if (tooltip)
					$animate.leave(tooltip).then(function() { destroyTooltip(); });
			}

			function destroy() {
				$timeout.cancel(mouseEnterPromise);
				$timeout.cancel(mouseLeavePromise);
				destroyTooltip();
			}

			function reposition() {
				if (!tooltip)
					return;

				var opts = {
					my: 'left+' + (17 + options.tooltipOffset) + ' center',
					at: 'right center',
					of: elem,
					within: options.container,
					collision: 'flip fit',
					using: function (position, feedback) {
						$(this)
							// remember whether the tooltip is flipped so that we can show the arrow on the correct side
							.toggleClass('tooltip-arrow-right', feedback.horizontal === 'right')
							.css(position);
					}
				};

				$timeout(function () {
					if (tooltip)
						tooltip.position(opts);
				}, 0, false);
			}

			return {
				beginShow: beginShowTooltip,
				beginHide: beginHideTooltip,
				destroy: destroy
			};
		}

		return {
			createTooltip: createTooltip
		};
	}
	tooltipService.$inject = ['$q', '$timeout', '$document', '$animate', '_', '$'];
})();